import domContentLoaded from 'dom-content-loaded';
import $, { each } from 'jquery';

export default () => {
	domContentLoaded(() => {
		const $triggers = $('.js-child-nav-trigger');
		$triggers.each((index, trigger) => {
			$(trigger).on({
				mouseenter: () => {
					$(trigger).find('.js-child-nav').stop().slideDown(300);
				},
				mouseleave: () => {
					$(trigger).find('.js-child-nav').stop().slideUp(300);
				},
			});
		});
	});
};
